export default "__VITE_ASSET__DjhPbTNg__"